/**
 * @generated SignedSource<<40bea7a0fdc894a963cfa9c10f6ab746>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceVersionCloneButtonVersionFragment$data = {
  readonly id: string;
  readonly version: Semver;
  readonly workspace: {
    readonly id: string;
    readonly localSlug: string | null | undefined;
    readonly owner: {
      readonly id: string;
    };
    readonly private: boolean;
    readonly slug: string;
  };
  readonly " $fragmentType": "WorkspaceVersionCloneButtonVersionFragment";
};
export type WorkspaceVersionCloneButtonVersionFragment$key = {
  readonly " $data"?: WorkspaceVersionCloneButtonVersionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionCloneButtonVersionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceVersionCloneButtonVersionFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Workspace",
      "kind": "LinkedField",
      "name": "workspace",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "localSlug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "private",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v0/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WorkspaceVersion",
  "abstractKey": null
};
})();

(node as any).hash = "fe3a0bcc664a8d978d8cbebf2c27dfdf";

export default node;
